// K97 (AUDIT-B2, 23 Sep 2026) — frekuensi + cut-off rekap upah borongan, per region.
//
// Verbatim Owner 25 Agu 2026: "saat ini bulanan bisa jadi ada perubahan besok besok bisa
// mingguan atau 2 mingguan. Kepala cabang masing masing bisa menentukan cut off tanggalnya".
// Perubahan berlaku MAJU: periode yang sudah terbentuk tidak bergeser.
import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { apiErrorMessage } from "@/lib/inventoryApi";
import { toast } from "sonner";

const LABEL = { BULANAN: "Bulanan", DUA_MINGGUAN: "Dua mingguan", MINGGUAN: "Mingguan" };

function jelaskan(frek, acuan) {
  if (!acuan) return "";
  const d = new Date(`${acuan}T00:00:00`);
  if (frek === "BULANAN") {
    return `cut-off tiap tanggal ${d.getDate()}${d.getDate() >= 29 ? " (bulan yang lebih pendek: hari terakhirnya)" : ""}`;
  }
  const hari = d.toLocaleDateString("id-ID", { weekday: "long" });
  return `cut-off tiap ${frek === "MINGGUAN" ? "" : "dua minggu, "}${hari} (terhitung dari ${d.toLocaleDateString("id-ID")})`;
}

export default function SetelanPeriodeUpah({ regionId, setelan, bolehUbah, onTersimpan }) {
  const [ubah, setUbah] = useState(false);
  const [frek, setFrek] = useState(setelan?.frekuensi || "BULANAN");
  const [acuan, setAcuan] = useState(setelan?.tanggal_cutoff_acuan || "");
  const [sibuk, setSibuk] = useState(false);

  useEffect(() => {
    setFrek(setelan?.frekuensi || "BULANAN");
    setAcuan(setelan?.tanggal_cutoff_acuan || "");
  }, [setelan]);

  async function simpan() {
    setSibuk(true);
    try {
      const r = await api.put(`/borongan/periode/setelan/${regionId}`, { frekuensi: frek, tanggal_cutoff_acuan: acuan });
      toast.success(r.data.berlaku_mulai
        ? `Setelan disimpan — berlaku untuk periode mulai ${new Date(`${r.data.berlaku_mulai}T00:00:00`).toLocaleDateString("id-ID")}.`
        : "Setelan disimpan.");
      setUbah(false);
      onTersimpan && onTersimpan();
    } catch (e) {
      toast.error(apiErrorMessage(e, "Setelan ditolak."));
    } finally {
      setSibuk(false);
    }
  }

  return (
    <div className="rounded-xl border border-border bg-card p-4 text-sm space-y-2" data-testid="setelan-periode-upah">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <span>
          <span className="font-medium text-foreground">Periode rekap: {LABEL[setelan?.frekuensi] || setelan?.frekuensi}</span>
          <span className="ml-2 text-muted-foreground">{jelaskan(setelan?.frekuensi, setelan?.tanggal_cutoff_acuan)}</span>
        </span>
        {bolehUbah && !ubah && (
          <button type="button" className="text-sm underline" onClick={() => setUbah(true)} data-testid="setelan-periode-ubah">
            Ubah cut-off
          </button>
        )}
      </div>
      {ubah && (
        <div className="flex flex-wrap items-end gap-2">
          <label className="block">
            <span className="mb-1 block text-xs text-muted-foreground">Frekuensi</span>
            <select className="rounded-lg border border-input bg-background px-3 py-2 text-sm"
                    value={frek} onChange={(e) => setFrek(e.target.value)}>
              {Object.entries(LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </label>
          <label className="block">
            <span className="mb-1 block text-xs text-muted-foreground">Contoh tanggal cut-off</span>
            <input type="date" className="rounded-lg border border-input bg-background px-3 py-2 text-sm"
                   value={acuan} onChange={(e) => setAcuan(e.target.value)} />
          </label>
          <button type="button" disabled={sibuk || !acuan}
                  className="rounded-lg border border-input px-3 py-2 text-sm" onClick={simpan}>Simpan</button>
          <button type="button" className="px-3 py-2 text-sm text-muted-foreground" onClick={() => setUbah(false)}>Batal</button>
          <p className="basis-full text-xs text-muted-foreground">
            {jelaskan(frek, acuan)}. Berlaku untuk periode yang BELUM terbentuk; periode yang sudah ada tidak bergeser.
          </p>
        </div>
      )}
    </div>
  );
}
